<rw-modal
  modalId="closeOrganizationModal"
  datapendoid="close-organization-modal"
  datatestid="close-organization-modal"
  [title]="'Close Organization'"
  arialabel="Close Organization"
  [dismissible]="false"
  size="lg"
  #modalRef
>
  <div modal-body>
    <div class="row">
      <div>
        <div class="p-field">
          <p>
            You are about to cancel the organization <b>{{ orgName }}</b
            >.
            @if (hasPkgActions || hasUserActions) {
              The process will perform the following {{ actionText }} and will convert the organization to a folder.
            } @else {
              The process will convert the organization to a folder.
            }
            You will still be able to access the data but will no longer be able to add users, licenses, or packages.<br />
          </p>
        </div>

        <div class="no-margin-well m-b-1rem">
          @if (orgHasSubOrgs) {
            <p class="black">
              All users in this organization or in an organization under it must be logged out of their cloud-hosted
              desktop to start the process, and you will not be able to use AppHub while this is in progress.<br />
            </p>
          }
          @if (hasPkgActions || hasUserActions) {
            <ul>
              <li><strong>Delete:</strong> {{ userCount }} {{ userText }}</li>
              @for (package of droppedPackages; track package.Name) {
                <li>
                  <strong>Drop {{ package.Name }}:</strong> (QTY: {{ package.QTY }})
                </li>
              }
            </ul>
          }
        </div>
        <p><strong>Are you sure you want to do this?</strong></p>
      </div>
    </div>
  </div>
  <div modal-footer>
    <app-button id="btnClose" buttonStyle="addUserTeritary" label="CANCEL" (clickActionEmitter)="close()"></app-button>
    <app-button
      id="btnConfirm"
      buttonStyle="dontCreateUserButton"
      label="CANCEL ORGANIZATION"
      (clickActionEmitter)="confirm()"
    >
    </app-button>
  </div>
</rw-modal>
